<template>
  <div class="mx-2 pt-2 py-2" style="background-color: #f9f9f9; height: 110vh">
    <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">
      Create Daily Roaster
    </h1>
    <form class="max-w-md mx-auto" @submit.prevent="submit">
      <div class="mb-5">
        <div date-rangepicker class="md:pt-0 pt-5 flex-wrap items-center">
          <span class="text-black text-sm">Date From</span>
          <div class="relative mb-5 mt-4">
            <input required @change="validateDateRange" name="start" type="date" v-model="startDate"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Select Date From" />
          </div>
          <span class="text-black text-sm pt-3">Date To</span>
          <div class="relative sm:pt-4 sm:pb-0 pb-5 pt-4">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"></div>
            <input required @change="validateDateRange" name="end" type="date" v-model="endDate"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Select Date To" />
          </div>
        </div>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Shift</label>
        <select required v-model="shift_id" style="height: 40px"
          class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="0">Select shift</option>
          <option v-for="shift in selectshift" :key="shift.id" :value="shift.id">
            {{ shift.shift }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="text" class="block mb-2 text-sm font-medium text-black dark:text-white">
          All Cities</label>
        <select @change="countryChanged" v-model="selectDistrictid" id="selectDistrictid"
          class="font-family-card text-[16px] rounded bg-white border mb-3 border-gray-300 text-black text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected value="all">All Cities</option>
          <option v-for="district in selectDistrict" :key="district.id" :value="district.id">
            {{ district.name }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select
          Hospital</label>
        <select id="hospitals" ref="staffHospital" multiple  v-model="hospital_id" style="height: 40px"
          class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="0">Select Hospital</option>
          <option v-for="hospital in countries" :key="hospital.id" :value="hospital.id">
            {{ hospital.name }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select staff</label>
        <select  multiple ref="staffSelect" v-model="staff_id" id="staff" style="height: 40px"
          class="js-example-disabled-results bg-white rounded border mr-3 border-gray-300 text-black text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option  v-for="staf in staff" :key="staf.id" :value="staf.id">
            {{ staf.name }} - {{ staf.type }}
          </option>
        </select>
      </div>
      <div class="mb-5" v-if="teamshow">
        <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Collector's Team</label>
        <input type="text" v-model="team" id="username"
          class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
          placeholder="Team A" required />
      </div>
      <div class="flex items-center mt-5 justify-center">
        <router-link to="dailyroaster"
          class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Back</router-link>
        <button type="submit"
          class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Create Daily Roaster
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUpdated, onUnmounted } from "vue";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";
import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();

const router = useRouter(); // Initialize the router object
const endDate = ref();
const selectHospitals = ref([]);
const hospital_id = ref(0);
const staff = ref([]);
const staff_id = ref([]);
const teamshow = ref(false);
const selectshift = ref([]);
const shift_id = ref(0);
const startDate = ref();
const selectDistrict = ref([]);
const selectDistrictid = ref("all");
const team = ref();
const countries = ref([]);
import $ from "jquery";
import "select2";
import axiosInstance from "@/plugins/axios";

watch(
  () => staff_id.value,
  (newData) => {
    // If staff_id is an array, handle each ID separately
    if (Array.isArray(newData)) {
      const selectedStaffArray = newData.map((id) => {
        // Find the corresponding staff object based on staff_id
        return staff.value.find((staf) => staf.id === Number(id));
      });
      const isCollector = selectedStaffArray.some((staf) => staf && staf.type === "Collector");
      if (isCollector !== teamshow.value) {
        teamshow.value = isCollector;
      }
    } else {
      const selectedStaff = staff.value.find((staf) => staf.id === Number(newData));
      const isCollector = selectedStaff && selectedStaff.type === "Collector";
      if (isCollector !== teamshow.value) {
        teamshow.value = isCollector;
      }
    }
  }
);

const validateDateRange = () => {
  const startDateObj = new Date(startDate.value);
  const endDateObj = new Date(endDate.value);

  if (startDateObj > endDateObj) {
    alert("To date must be greater or equal to from date");
    endDate.value = ""; // Reset end date to prevent an invalid date range
  }
};
const fetchCountries = async () => {
  try {
    const response = await axiosInstance.get("/all-districts"); // Replace with your API endpoint
    const districts = response.data.data;
    countryChanged();
    // Extracting all district names
    const districtNames = districts.map((district) => district);
    selectDistrict.value = districtNames;
  } catch (error) {
    console.error("Error fetching countries:", error);
    // Handle error or show error message
  }
};
const changestaff = () => {
  staff_id.value = $("#staff").val();
};
const changehospital = () => {
 getstaff()
  // staff_id.value = $("#hospitals").val();
};
const countryChanged = async () => {
  try {
    const response = await axiosInstance.get(
      `/districts/${selectDistrictid.value}/incineration-hospitals`
    );
    const countery = response.data.data;
    const counterys = countery.map((countery) => countery);
    countries.value = counterys;
  } catch (error) {
    console.error("Error fetching district info:", error);
    // Handle error or show error message
  }
};
const getHospitals = () => {
  const hospitalId = 100000000;
  axiosInstance
    .get(`/hospitals/${hospitalId}`)
    .then((response) => {
      const hospital = response.data.data.data;
      const districtNames = hospital.map((hospitals) => hospitals);
      selectHospitals.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const getShift = () => {
  const shiftid = 100000000;
  axiosInstance
    .get(`/shifts-paginate/${shiftid}`)
    .then((response) => {
      selectshift.value = response.data.data.data;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const getstaff = () => {
  const selectedHospitals = $("#hospitals").val();
  // console.log(selectedHospitals,'sssssssssss');
  axiosInstance
    .get(`/hospitals/${selectedHospitals}/staffs/`)
    .then((response) => {
      const shift = response.data.data;
      const districtNames = shift.map((hospitals) => hospitals);
      staff.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};

const submit = async () => {
  try {
    const selectedHospitals = $("#hospitals").val();
    // Check if more than one hospital is selected
    if (selectedHospitals && selectedHospitals.length > 1) {
      // Show a warning message
      Swal.fire({
        title: "Warning",
        text: "Please select only one hospital.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    }

    const response = await axiosInstance.post(`/daily-roaster`, {
      start_date: startDate.value,
      end_date: endDate.value,
      staff_ids: $("#staff").val(),
      hospital_id: selectedHospitals ? selectedHospitals[0] : null,
      shift_id: shift_id.value,
      team: team.value,
    });

    Swal.fire({
      toast: true,
      title: "DailyRoaster created successfully.",
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });

    router.push({ name: "DailyRoaster" });
  } catch (error) {
    console.error("Error fetching DailyRoaster info:", error);
    Swal.fire({
      toast: true,
      title: error.response.data.message,
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
};

const staffSelect = ref(null)
const staffHospital = ref(null)

onMounted(() => {
  $(staffSelect.value).select2();
  $(staffHospital.value).select2();

  $(staffSelect.value).on("change", () => {
    changestaff();
  });
  $(staffHospital.value).on("change", () => {
    changehospital();
  });
  const id = router.currentRoute.value.params.id;
  // roleId.value = id
  getShift();
  getHospitals();
});

$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#staff").select2({
    placeholder: "Select Staff",
    allowClear: true,
  });
});

$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitals").select2({
    placeholder: "Select Hospital",
    allowClear: true,
  });
});
onMounted(async () => {
  await fetchCountries();
  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>